import changelogAPI from '../../../api/changelogAPI';

const API = new changelogAPI();

const state = {
  items: [],
  loading: {
    many: false,
  },
  errors: null,
  total: 0,
  viewAsAdmin: false,
};

const getters = {};

const actions = {
  index({ commit }, data = {}) {
    commit('clearChangelog');
    commit('setLoadingMany', true);
    return API.index(data).then(response => {
      Array.from(response.data.items).forEach(log => {
        commit('appendLog', {
          color: 'primary',
          icon: 'DatabaseIcon',
          log: log,
        });
      });
      commit('setTotal', response.data.total);
    })
      .finally(() => {
        commit('setLoadingMany', false);
      });
  },
  admin({ commit }, data = {}) {
    commit('clearChangelog');
    commit('setLoadingMany', true);
    return API.admin(data).then(response => {
      Array.from(response.data.items).forEach(log => {
        commit('appendLog', {
          color: 'primary',
          icon: 'DatabaseIcon',
          log: log,
        });
      });
      commit('setTotal', response.data.total);
    })
      .finally(() => {
        commit('setLoadingMany', false);
      });
  },
  store({ commit }, data) {
    return API.store(data).catch(({ response }) => {
      commit('setErrors', response.data.error);
    });
  },
  update({ commit }, data) {
    return API.update(data.id, data);
  },
  delete({ commit }, id) {
    return API.delete(id);
  },
  publish({ commit }, id) {
    return API.publish(id);
  },
  unpublish({ commit }, id) {
    return API.unpublish(id);
  },
};

const mutations = {
  clearChangelog(state) {
    state.items = [];
  },
  appendLog(state, log) {
    state.items.push(log);
  },
  setLoadingMany(state, value) {
    state.loading.many = value;
  },
  setTotal(state, value) {
    state.total = value;
  },
  setErrors(state, errors) {
    state.errors = errors;
  },
  setViewAsAdmin(state, value) {
    state.viewAsAdmin = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
